/**
 * Whether the signed-in user holds a permission.
 *
 * Components render capabilities, never roles: `role === 'merchant'` scattered
 * through the UI is what makes adding a role a frontend rewrite instead of a
 * seeder change. Lives in lib/ rather than api/ops.ts so the merchant portal
 * can use it without importing the ops console's module.
 *
 * Hiding a control is courtesy, not access control — every endpoint behind it
 * does its own check. This only avoids offering something that would 403.
 * `undefined` (still loading) reads as "no", so gated things arrive late
 * rather than being wrongly shown.
 */
export function can(
    user: { permissions: readonly string[] } | undefined,
    permission: string,
): boolean {
    return user?.permissions.includes(permission) ?? false;
}
